import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { createProvider } from './vue-apollo'
import './quasar'
import './components/globals'
import axios from 'axios'

Vue.prototype.$axios = axios

import { nl2brFunction } from './js/utilities'
Vue.prototype.$nl2br = nl2brFunction;
import { dayOfWeekStr } from './js/dateUtilities'
Vue.prototype.$dayOfWeekStr = dayOfWeekStr;
import { monthStr } from './js/dateUtilities'
Vue.prototype.$monthStr = monthStr;
import { dayStr } from './js/dateUtilities'
Vue.prototype.$dayStr = dayStr;
import { str2date } from './js/dateUtilities'
Vue.prototype.$str2date = str2date;

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

// import Vidle from 'v-idle'
import Vidle from './js/stereo-vidle.min.js'
Vue.use(Vidle)


Vue.prototype.$eventBus = new Vue();
Vue.prototype.$generalSettings = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app')
